module.exports = __webpack_public_path__ + "static/media/logo_200.ff66aa4d.png";